import script from "./contactPage.vue?vue&type=script&setup=true&lang=js"
export * from "./contactPage.vue?vue&type=script&setup=true&lang=js"

import "./contactPage.vue?vue&type=style&index=0&id=2eb15843&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2eb15843"]])

export default __exports__